import gql from 'graphql-tag'

export const MYJOURNEY_CREATE_MUTATION = gql`
mutation CreateMyjourney($input: CreateMyJourneyInputType!) {
  createMyjourney(input: $input) {
    myjourney {
      url
    }
    ok
  }
}
`

export const MYJOURNEY_LIST_QUERY = gql`
query MyJourneys(
  $limit: Int, 
  $offset: Int,
  $language: String, 
  $filter: String,
  $orderBy: String,
  $order: String,
  $departureId: ID,  
  $destinationId: ID,
  $citizenshipId: ID,
  $restrictionType: String,
  $dateStart: Date,
  $dateEnd: Date,
  $transitId: ID,
  $note: String,
  $shippingLineId: ID,
  $route: String
) {
  myjourneys(
    limit: $limit,
    offset: $offset,
    language: $language,
    filter: $filter,
    orderBy: $orderBy,
    order: $order,
    departureId: $departureId,
    destinationId: $destinationId,
    restrictionType: $restrictionType,
    citizenshipId: $citizenshipId,
    dateStart: $dateStart,
    dateEnd: $dateEnd,
    transitId: $transitId,
    note: $note,
    shippingLineId: $shippingLineId,
    route: $route
  ) {
    results{
      id
      departureName
      restrictionType
      dateStart
      dateEnd
      email
      isActive
      isManuallyDisabled
      language
      internalNote
      createdAt
      link
      transits {
        transitName
      }

      destinations {
        destinationName
      }

      cruises {
        cruiseName
        shippingLine
      }

      citizenships {
        citizenshipCountry {
          iso2
          nameShort
        }
      }
    }
    totalCount
  }
}
`

export const UPDATE_MY_JOURNEY_NOTE_EMAIL_MUTATION = gql`
mutation updateMyJourneyNoteEmail($input: UpdateMyJourneyNoteEmailInputType!) {
  updateMyjourneyEmailNote(input: $input) {
    ok
    error
    id
  }
}
`